import { render } from "./BusinessCard.vue?vue&type=template&id=77ec48d7&scoped=true&ts=true"
import script from "./BusinessCard.vue?vue&type=script&lang=ts"
export * from "./BusinessCard.vue?vue&type=script&lang=ts"

import "./BusinessCard.vue?vue&type=style&index=0&id=77ec48d7&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ec48d7"]])

export default __exports__